import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';

import * as Api from '../../../api/api';

import { LanguageCode } from '../../../util/languages';

export const updateEmployeeGroupAnnouncement = (
  orgId: number,
  announcementId: number,
  update: {
    languageToMessage?: Record<LanguageCode, string>;
    languageToSubject?: Record<LanguageCode, string>;
    cancelledAt?: string | null;
  },
) =>
  createGenericDispatcher<Announcement>({
    name: 'UPDATE_ANNOUNCEMENT',
    loadFunction: () => {
      const newAnnouncement: Partial<Announcement> = {};
      const { languageToMessage, languageToSubject, cancelledAt } = update;
      if (languageToMessage && languageToSubject) {
        const languages = Object.keys(languageToMessage);
        if (languages.length === 1) {
          const [language] = languages;
          newAnnouncement.messageBody = languageToMessage[language];
          newAnnouncement.subject = languageToSubject[language];
        } else {
          newAnnouncement.messageBody = languageToMessage.en;
          newAnnouncement.subject = languageToSubject.en;
          newAnnouncement.spanishMessageBody = languageToMessage.es;
          newAnnouncement.spanishSubject = languageToSubject.es;
        }
      }
      if (cancelledAt) {
        newAnnouncement.cancelledAt = cancelledAt;
      }

      return Api.post(`/announcements/${announcementId}`, {
        body: JSON.stringify({
          ...newAnnouncement,
        }),
      });
    },
    args: { announcementId, update, orgId },
  });
